"use client";

import { Popover, PopoverTrigger, PopoverContent } from "@/components";
import { Button } from "@/components";
import Link from "next/link";
import { IoHelpOutline } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { usePlatform } from "@/hooks/usePlatform";
import { useState } from "react";

const externalLinks = [
  {
    href: "https://www.veolia.fr/barometre-transformation-ecologique",
    label: "Consulter le baromètre de la transformation écologique (national)"
  },
  {
    href: "https://www.veolia.fr/barometre-transformation-ecologique",
    label: "Consulter le baromètre de votre région"
  },
  {
    href: "https://www.veolia.fr/sites/g/files/dvc2401/files/document/2025/02/Livre-blanc-ecologie-pour-quoi-faire.pdf",
    label: "Consulter le livre blanc"
  },
];

const internalLinks = [
  { href: "/conditions-generales-utilisation", label: "Conditions Générales d'Utilisation" },
  { href: "/charte-ethique", label: "Charte éthique" },
  { href: "/declaration-accessibilite", label: "Déclaration d'accessibilité" },
  { href: "/mentions-legales", label: "Mentions légales" },
  { href: "/utilisation-cookies", label: "Utilisation des cookies" },
];

export default function HelpButton() {
  const { isMobile } = usePlatform();
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="secondary"
          size="icon"
          aria-label="Aide"
          className="flex rounded-full bg-white text-primary shadow-lg hover:bg-primary hover:text-white data-[state=open]:bg-primary data-[state=open]:text-white"
        >
          <IoHelpOutline className="w-8 h-8" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align={isMobile ? "center" : "start"}
        className="p-0 w-80 bg-white rounded-2xl shadow-xl border-none"
      >
        <div className="flex flex-col p-6">
          {/* Section: Les ressources */}
          <div className="mb-4">
            <h3 className="text-sm font-medium text-gray-500 mb-3">Les ressources</h3>
            <div className="flex flex-col gap-2">
              {externalLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base font-normal hover:underline focus:outline-none focus:underline flex items-start gap-2"
                  onClick={handleLinkClick}
                >
                  <FiExternalLink className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>{link.label}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Séparateur */}
          <div className="border-t border-gray-200 my-4" />

          {/* Section: VictorIA */}
          <div>
            <h3 className="text-sm font-medium text-gray-500 mb-3">VictorIA</h3>
            <div className="flex flex-col gap-2">
              {internalLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="text-base font-normal hover:underline focus:outline-none focus:underline"
                  onClick={handleLinkClick}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
